/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Grid } from "@mui/material";

import image_header from "../assets/landing/SimpliCity-logo-2025.svg";
// import { ReactComponent as SimplyCreate } from "../assets/landing/simply_create.svg";
// import { ReactComponent as SimplifyTheComplex } from "../assets/landing/simplifying_the_complex.svg";
import image1 from "../assets/landing/simply_create.png";
import image2 from "../assets/landing/simplifying_the_complex.png";
import image3 from "../assets/landing/save_time_reuse.png";
import image4 from "../assets/landing/fast_and_secure.png";
import image5 from "../assets/landing/developer_friendly.png";

// import { ReactComponent as SimplyCreate } from "assets/landing/simply_create.svg";
// import { ReactComponent as SimplifyTheComplex } from "assets/landing/simplifying_the_complex.svg";

const WelcomeMessaging = () => {
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item>
                    <div className="welcome-layout">
                        <div className="bodyContainer">
                            <div className="welcomeImageBlock welcomeImageBlockInner">
                                <div className="welcomeImageContent">
                                    <img alt="" src={image_header} width="537.6" className="welcomeRetinaImage" />
                                </div>
                            </div>
                            <div className="welcomeTextBlock">
                                <div className="welcomeTextBlockInner">
                                    <div className="subhead-div">
                                        <div className="welcomeTextContent">
                                            <h4 className="header-4">Inform. Serve. Engage.</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="header-top-div">
                                <h1 className="header-top">
                                    Reach your municipality&apos;s digital transformation goals faster.
                                </h1>
                            </div>

                            <div width="100%" className="welcomeTextBlock2">
                                <div className="welcomeTextBlockInner">
                                    <div className="subhead-div">
                                        <div className="welcomeTextContent3">
                                            <div className="text-div">
                                                SimpliCity is a website and data integration platform that makes it easy
                                                to manage public-facing digital information and services.
                                                <br />
                                                <br />
                                                SimpliCity uses a combination of a flexible API-first headless CMS, a
                                                content creation web console, an automated publishing process, and
                                                secure Canadian cloud hosting for municipal websites and applications.
                                                <br />
                                                <br />
                                                Communications teams can easily create, share, and reuse content, while
                                                IT teams can build their own apps and customizations if they choose.
                                                <br />
                                                <br />
                                                With integration services built at its core, SimpliCity can be used for
                                                citizen-focused websites and self-service portals, and provides useful
                                                microservices that securely connect to municipal data, tools, and
                                                systems.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="welcomeDividerBlock">
                                <div className="welcomeDividerBlockInner">
                                    <div className="welcomeDividerContent"></div>
                                </div>
                            </div>
                            <div className="welcomeDividerBlock">
                                <div className="welcomeDividerBlockInner">
                                    <div className="welcomeDividerContent"></div>
                                </div>
                            </div>
                            <div className="welcomeCaptionBlock">
                                <div className="welcomeCaptionBlockInner">
                                    <div className="welcomeCaptionColumn">
                                        <div className="section-div-right">
                                            <div className="welcomeCaptionRightContentInner">
                                                {/*<SimplyCreate*/}
                                                {/*    alt="Simply Create" */}
                                                {/*    width="150"*/}
                                                {/*    className="welcomeImage"*/}
                                                {/*/>*/}
                                                <img alt="" src={image1} width="150" className="welcomeImage" />
                                            </div>
                                        </div>
                                        <div className="section-div-left">
                                            <div className="welcomeTextContent">
                                                <h3 className="header-3c">Simply create</h3>
                                                <p className="landing-para-left">
                                                    Content creators can just let it all flow by using our intuitive
                                                    composer writing tools. Daily ease of use is a primary focus for
                                                    SimpliCity.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="welcomeDividerBlock">
                                <div className="welcomeDividerBlockInner">
                                    <div className="welcomeDividerContent"></div>
                                </div>
                            </div>
                            <div className="welcomeCaptionBlock">
                                <div className="welcomeCaptionBlockInner">
                                    <div className="welcomeCaptionColumn">
                                        <div className="section-div-left">
                                            <div className="welcomeTextContent">
                                                <h3 className="header-3b">Simplifying the complex</h3>
                                                <p className="landing-para-right">
                                                    Need to insert complex interactions like image carousels, accordion
                                                    sections, videos, maps, or forms into your website? You can do it
                                                    all within the flow of paragraphs and sections, without needing to
                                                    jump to another page in the console, and without needing support
                                                    from IT.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="section-div-right">
                                            <div className="welcomeCaptionRightContentInner">
                                                <img alt="" src={image2} width="150" className="welcomeImage" />
                                                {/*<SimplifyTheComplex */}
                                                {/*    alt="Simplify The Complex"*/}
                                                {/*    width="150"*/}
                                                {/*    className="welcomeImage"*/}
                                                {/*/>*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="welcomeDividerBlock">
                                <div className="welcomeDividerBlockInner">
                                    <div className="welcomeDividerContent"></div>
                                </div>
                            </div>
                            <div className="welcomeCaptionBlock">
                                <div className="welcomeCaptionBlockInner">
                                    <div className="welcomeCaptionColumn">
                                        <div className="section-div-right">
                                            <div className="welcomeCaptionRightContentInner">
                                                <img alt="" src={image3} width="150" className="welcomeImage" />
                                            </div>
                                        </div>
                                        <div className="section-div-left">
                                            <div className="welcomeTextContent2">
                                                <h3 className="header-3a">Save time, reuse</h3>
                                                <p className="landing-para-left">
                                                    Manually updating changed information over multiple webpages is a
                                                    thing of the past. SimpliCity’s reusable content means you can
                                                    update information in one place, and it automatically changes
                                                    everywhere else it is referenced.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="welcomeDividerBlock">
                                <div className="welcomeDividerBlockInner">
                                    <div className="welcomeDividerContent"></div>
                                </div>
                            </div>
                            <div className="welcomeCaptionBlock">
                                <div className="welcomeCaptionBlockInner">
                                    <div className="welcomeCaptionColumn">
                                        <div className="section-div-left">
                                            <div className="welcomeTextContent2">
                                                <h3 className="heading-3">Fast and secure</h3>
                                                <p className="landing-para-right">
                                                    SimpliCity’s architecture isolates the website from content creation
                                                    servers, thereby considerably improving security. Websites hosted on
                                                    SimpliCity have ultra-high performance enabled through our content
                                                    distribution network (CDN).
                                                </p>
                                            </div>
                                        </div>
                                        <div className="section-div-right">
                                            <div className="welcomeCaptionLeftContentInner">
                                                <img alt="" src={image4} width="150" className="welcomeImage" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="welcomeDividerBlock">
                                <div className="welcomeDividerBlockInner">
                                    <div className="welcomeDividerContent"></div>
                                </div>
                            </div>

                            <div className="welcomeCaptionBlock">
                                <div className="welcomeCaptionBlockInner">
                                    <div className="welcomeCaptionColumn">
                                        <div className="section-div-right">
                                            <div className="welcomeCaptionRightContentInner">
                                                <img alt="" src={image5} width="150" className="welcomeImage" />
                                            </div>
                                        </div>
                                        <div className="section-div-left">
                                            <div className="welcomeTextContent2">
                                                <h3 className="section-header-left">Developer-friendly</h3>
                                                <p className="landing-para-left">
                                                    If your municipality likes to develop new and interesting solutions,
                                                    SimpliCity was architected for that too. Unlike most CMS platforms,
                                                    SimpliCity does not save content as HTML. Instead, content is saved
                                                    in an easily accessible JSON structure that enables your content to
                                                    be reusable and multi-channel. Reuse content in other web apps,
                                                    mobile apps, chatbots, smart speakers, and more. Not interested in
                                                    developing new features yourself? Our roadmap includes releasing
                                                    many municipal-specific features and integrations over time, and we
                                                    place a high importance on customer feedback to prioritize them.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default WelcomeMessaging;
